import React, { useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import ContactForm from '../components/contact/ContactForm';
import { ContactSEO } from '../components/layout/SEO';
import { usePageData } from '../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../components/common/LoadingSpinner';

const ContactPage = () => {
  const { data: contactPage, isLoading } = usePageData('contactPage');

  React.useEffect(() => {
    document.body.style.paddingTop = '50px';
    return () => {
      document.body.style.paddingTop = '0';
    };
  }, []);

  if (isLoading) {
    return (
      <div className="contact-page">
        <div className="container">
          <LoadingSkeleton type="card" count={3} />
        </div>
      </div>
    );
  }

  return (
    <HelmetProvider>
      <div className="contact-page">
        <ContactSEO pageData={contactPage} />
        <ContactForm />
        
        
      </div>
    </HelmetProvider>
  );
};

export default ContactPage;